// utils/topUpErrorHandler.js
export const validateTopUpInput = ({ selectedAmount, voucher, promoDiscount = 0, currency = "" }) => {
  if (!selectedAmount || selectedAmount <= 0) return "Select amount";
  if (promoDiscount > 0 && selectedAmount < promoDiscount) {
    return `Amount must be ≥ promo ${promoDiscount} ${currency}`;
  }
  return null;
};

export function parseTopUpError(error) {
  const status = error?.status || error?.response?.status;
  const detail = error?.message || error?.response?.data?.detail || error?.response?.data?.error || "Top-up failed.";

  if (typeof detail === "string") {
    if (detail.toLowerCase().includes("insufficient funds")) {
      return "Insufficient funds for this operation.";
    }
    if (detail.toLowerCase().includes("invalid wallet")) {
      return "Invalid wallet ID.";
    }
    if (detail.toLowerCase().includes("invalid provider")) {
      return "Payment provider not available.";
    }
    if (detail.toLowerCase().includes("promocode") || detail.toLowerCase().includes("voucher")) {
      return "Invalid or expired voucher code.";
    }
  }

  if (!status) {
    return "Connection error. Please check your internet connection and try again.";
  }

  switch (status) {
    case 400:
      return "Invalid data. Please check your input and try again.";
    case 401:
      return "Your session has expired. Please sign in again.";
    case 403:
      return "You are not authorized to perform this operation.";
    case 422:
      return "Data validation failed. Please check your input.";
    case 500:
      return "Server error. Please try again later.";
    case 502:
    case 503:
    case 504:
      return "Payment service is temporarily unavailable. Please try again in a moment.";
    default:
      return "Top-up failed. Please try again or contact support.";
  }
}
